export default "__VITE_ASSET__7rBagcok__"